import product1img1 from './img/shop/shop2/lu1.jpg'
import product1img2 from './img/shop/shop2/lu2.jpg'
import product1img3 from './img/shop/shop2/lu3.jpg'

import product2img1 from './img/shop/shop2/zo3.jpg'
import product2img2 from './img/shop/shop2/zo2.jpg'
import product2img3 from './img/shop/shop2/zo1.jpg'

import product3img1 from './img/shop/shop2/ll1.jpg'
import product3img2 from './img/shop/shop2/ll2.jpg'
import product3img3 from './img/shop/shop2/ll3.jpg'

import product4img1 from './img/shop/shop2/li2.jpg'
import product4img2 from './img/shop/shop2/li3.jpg'
import product4img3 from './img/shop/shop2/li1.jpg'

export const PRODUCTS2 = [
    {
        id: 9,
        amount: 1,
        route: 'product9',
        name: "AniStore",
        title: "Luffy Collectible Figurines",
        price: 59.99,
        description: 'Our Figurines are a collectible, three-dimensional representation of a character from an Anime or Manga series. These figurines are meticulously designed and crafted to capture the appearance, costume, and distinct features of the characters. They are often made from materials like PVC (polyvinyl chloride) and come in various sizes, ranging from a few inches to over a foot in height. Our figurines are sought after by fans and collectors alike, allowing them to bring a piece of their favorite anime world into their physical space. Whether posed in iconic stances, dynamic action poses, or displaying signature techniques, these figurines celebrate the vibrant and adventurous world of Anime and Manga series',
        image1: product1img1,
        image2: product1img2,
        image3: product1img3,
    },
    {
        id: 10,
        amount: 1,
        route: 'product10',
        name: "AniStore",
        title: "Zoro Collectible Figurines",
        price: 59.99,
        description: 'Our Figurines are a collectible, three-dimensional representation of a character from an Anime or Manga series. These figurines are meticulously designed and crafted to capture the appearance, costume, and distinct features of the characters. They are often made from materials like PVC (polyvinyl chloride) and come in various sizes, ranging from a few inches to over a foot in height. Our figurines are sought after by fans and collectors alike, allowing them to bring a piece of their favorite anime world into their physical space. Whether posed in iconic stances, dynamic action poses, or displaying signature techniques, these figurines celebrate the vibrant and adventurous world of Anime and Manga series',
        image1: product2img1,
        image2: product2img2,
        image3: product2img3,
    },
    {
        id: 11,
        amount: 1,
        route: 'product11',
        name: "AniStore",
        title: "Lawliet Collectible Figurines",
        price: 59.99,
        description: 'Our Figurines are a collectible, three-dimensional representation of a character from an Anime or Manga series. These figurines are meticulously designed and crafted to capture the appearance, costume, and distinct features of the characters. They are often made from materials like PVC (polyvinyl chloride) and come in various sizes, ranging from a few inches to over a foot in height. Our figurines are sought after by fans and collectors alike, allowing them to bring a piece of their favorite anime world into their physical space. Whether posed in iconic stances, dynamic action poses, or displaying signature techniques, these figurines celebrate the vibrant and adventurous world of Anime and Manga series',
        image1: product3img1,
        image2: product3img2,
        image3: product3img3,
    },
    {
        id: 12,
        amount: 1,
        route: 'product12',
        name: "AniStore",
        title: "Light Collectible Figurines",
        price: 59.99,
        description: 'Our Figurines are a collectible, three-dimensional representation of a character from an Anime or Manga series. These figurines are meticulously designed and crafted to capture the appearance, costume, and distinct features of the characters. They are often made from materials like PVC (polyvinyl chloride) and come in various sizes, ranging from a few inches to over a foot in height. Our figurines are sought after by fans and collectors alike, allowing them to bring a piece of their favorite anime world into their physical space. Whether posed in iconic stances, dynamic action poses, or displaying signature techniques, these figurines celebrate the vibrant and adventurous world of Anime and Manga series',
        image1: product4img1,
        image2: product4img2,
        image3: product4img3,
    }
]